/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import EditScheduleNoteDialog from './EditScheduleNoteDialog/index'
import React from 'react'
import ViewNoteDialog from './ViewNoteDialog/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note",
  triggerRef,
  onMouseEnterTrigger,
  onMouseMoveTrigger,
  onMouseLeave,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent,
  onClose
  
}) {
let eventScheduleNoteDisplayValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'schedule_note.display',
})
let constantData = 'block'
let aggregateData = fromAggregate.equals(eventScheduleNoteDisplayValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Note.Vertical"
  data-view-path={viewPath}
 ref={triggerRef}
 onMouseEnter={onMouseEnterTrigger}
 onMouseMove={onMouseMoveTrigger}
 onMouseLeave={onMouseLeave}
 style={{'--w-1-aI8I': aggregateData ? "auto" : "16px",'--bblr-5-aI8I': aggregateData ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : "18px",'--bbrr-6-aI8I': aggregateData ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : "18px",'--btlr-3-aI8I': aggregateData ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : "18px",'--btrr-4-aI8I': aggregateData ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : "18px",'--ai-7-aI8I': aggregateData ? "start" : "center",'--jc-8-aI8I': aggregateData ? "start" : "center",'--pt-11-aI8I': aggregateData ? typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs : "0px",'--pb-12-aI8I': aggregateData ? typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs : "0px",'--pl-9-aI8I': aggregateData ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px",'--pr-10-aI8I': aggregateData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : "0px",'--bc-2-aI8I': hovered ? "#f9e19a" : "#F8E3A3"}}
 className={`views-block ${styles.Vertical}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
<ViewNoteDialog
  viewPath={`${viewPath}/ViewNoteDialog`}
 top={top}
 left={left}
 isOpen={hovered}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
 onMouseLeave={onMouseLeave}
/>
<EditScheduleNoteDialog
  viewPath={`${viewPath}/EditScheduleNoteDialog`}
 top={top}
 left={left}
 contentRef={contentRef}
 onClose={onClose}
/>
{children}
</React.Fragment>)
}